export abstract class ResultadoController {
    sucesso: boolean;
    mensagemErro?: string;
}
